<template>
  <FormGroup :error-container="errorContainer" :label="label" :name="name" :floating="floating">
    <FmSelect :value="proxyValue" :options="options" :icons="icons" :disabled="disabled"
              @input="proxyValue = $event"/>
  </FormGroup>
</template>

<script>
import FormGroup from '@modules/shared/components/form/FormGroup';
import FmSelect from '@modules/shared/components/form/FmSelect';
import {StatesOfAustralia} from '@modules/guest/bought-lead/constants.js';

// Map-pin icon for every state entry
const PIN = `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/></svg>`;

export default {
  name: 'StateSelect',
  components: { FormGroup, FmSelect },
  model: { prop: 'value', event: 'input' },
  props: {
    name:           { type: String,  default: 'state' },
    label:          { type: String,  default: 'Driving Licence State' },
    value:          { type: String,  default: '' },
    disabled:       { default: false },
    errorContainer: { type: String,  default: '' },
    allowEmpty:     { type: Boolean, default: false },
    floating:       { type: Boolean, default: false },
  },
  computed: {
    options: () => StatesOfAustralia,
    icons() {
      return Object.fromEntries(Object.keys(StatesOfAustralia).map(k => [k, PIN]));
    },
    proxyValue: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
};
</script>
